import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AttacheOptions } from '@models/attache-options';
import { firstValueFrom } from 'rxjs';

export interface AttachePayload {
  signature: string;
  path: string;
  bytes: number;
  geometry: string;
  contentType: string;
}

@Injectable({ providedIn: 'root' })
export class AttacheService {
  private http = inject(HttpClient);

  upload(options: AttacheOptions, file: File): Promise<AttachePayload> {
    const params = new HttpParams()
      .set('uuid', options.uuid)
      .set('expiration', `${options.expiration}`)
      .set('hmac', options.hmac)
      .set('file', file.name);
    return firstValueFrom(this.http.put<AttachePayload>(options.uploadurl, file, { params }));
  }
}
